import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.storybook,
    element: loadable(() => import('./pages/StorybookPage')),
  },
];
